(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.phone-validate'
  const templateUrl = require('./tpl/phone-validate.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('../provider/phone-validate-api')
    ])
    .run(maskConfig)

  maskConfig.$inject = ['$q', 'formlyConfig', 'PhoneValidateApi']
  function maskConfig ($q, formlyConfig, PhoneValidateApi) {
    formlyConfig.setType({
      name: 'phone-validate',
      extends: 'input',
      templateUrl: templateUrl,
      defaultOptions: {
        modelOptions: {
          updateOn: 'blur'
        },
        asyncValidators: {
          phoneValidation: {
            expression: function (viewValue, modelValue, scope) {
              var phoneNumber = modelValue || viewValue
              return PhoneValidateApi.validate(phoneNumber)
                .then(function (response) {
                  if ('valid' in response && response.valid === true) {
                    return $q.resolve(true)
                  } else {
                    return $q.reject('Invalid phone number')
                  }
                })
            },
            message: '$viewValue + " is not a valid phone number"'
          }
        },
        templateOptions: {
        }
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      controller: phoneController
    })
  }

  phoneController.$inject = []
  function phoneController () {
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/phone-validate.js